var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRegisterDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 790,
    height: 982,
    viewBox: "0 0 790 982",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_65_1404)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H722C759.555 0 790 30.4446 790 68V914C790 951.555 759.555 982 722 982H0V0Z",
    fill: "#18191D"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_65_1404)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M613.582 688.821C567.521 671.223 516.302 675.1 467.408 681.458C418.513 687.816 368.755 696.388 320.268 687.424C271.781 678.46 223.742 647.47 210.61 599.95C199.652 560.287 214.511 518.771 223.263 478.559C232.008 438.346 231.961 389.962 200.405 363.549C176.668 343.682 142.193 342.952 111.863 349.114C81.532 355.276 52.2846 367.293 21.4123 369.554C-9.45991 371.815 -44.249 361.422 -58.8727 334.137C-80.3412 294.09 -48.425 241.64 -67.1069 200.219C-82.021 167.157 -125.876 154.872 -160.407 165.987C-194.929 177.102 -220.919 205.87 -240.354 236.499C-285.599 307.818 -303.488 393 -313.339 476.887C-325.2 577.877 -326.401 681.843 -298.135 779.521C-269.868 877.199 -209.317 968.543 -120.35 1017.79C-29.0131 1068.35 80.5351 1070.08 184.926 1068.72C336.234 1066.74 494.755 1058.87 625.011 981.855C673.591 953.142 723.106 899.908 719.017 840.409C714.558 775.526 675.86 712.613 613.582 688.821Z",
    fill: "#222429"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M633.064 597.993C628.031 586.539 631.874 572.71 643.323 567.828L648.261 565.398L648.656 566.203C658.636 564.319 668.48 568.811 673.483 578.087C678.491 587.374 675.468 598.292 667.786 605.052L668.176 605.842L663.239 608.272L663.229 608.252C652.038 614.404 638.067 609.386 633.064 597.993Z",
    fill: "#EAAE36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.002 595.562C643.005 606.956 656.976 611.974 668.167 605.821C679.069 599.826 684.33 586.61 678.426 575.657C672.526 564.724 659.908 560.43 648.261 565.398C636.817 570.279 632.974 584.108 638.002 595.562Z",
    fill: "#FFD576"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.118 592.549C647.607 600.494 657.35 603.993 665.153 599.705C672.759 595.527 676.425 586.306 672.308 578.67C668.196 571.044 659.396 568.051 651.273 571.515C643.293 574.918 640.609 584.559 644.118 592.549Z",
    fill: "#EAAE36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.256 588.691C654.337 587.977 654.631 587.258 655.122 586.549C655.593 585.87 656.236 585.136 657.036 584.372C657.477 583.946 657.857 583.561 658.161 583.217C658.434 582.913 658.616 582.62 658.697 582.346C658.768 582.108 658.738 581.86 658.601 581.581C658.434 581.242 658.186 581.065 657.826 581.035C657.411 580.999 656.88 581.136 656.257 581.44C655.634 581.749 655.051 582.133 654.525 582.594C653.993 583.06 653.441 583.632 652.894 584.296C652.823 584.382 652.712 584.432 652.596 584.422C652.484 584.412 652.378 584.351 652.317 584.255L650.894 581.966C650.813 581.835 650.828 581.662 650.93 581.541C651.34 581.085 651.871 580.579 652.504 580.047C652.788 579.809 653.097 579.581 653.436 579.358L652.261 577.282C652.211 577.196 652.201 577.095 652.231 577.004C652.261 576.913 652.327 576.832 652.413 576.791L654.216 575.905C654.302 575.865 654.403 575.854 654.495 575.89C654.586 575.925 654.657 575.996 654.697 576.082L655.609 578.244C656.348 577.966 657.036 577.814 657.664 577.794C658.581 577.763 659.391 577.961 660.07 578.381C660.748 578.796 661.28 579.399 661.66 580.164C662.044 580.948 662.191 581.698 662.09 582.387C661.994 583.06 661.731 583.713 661.305 584.326C660.9 584.913 660.399 585.506 659.821 586.093C659.264 586.655 658.809 587.146 658.459 587.547C658.145 587.911 657.943 588.24 657.862 588.529C657.786 588.787 657.826 589.061 657.978 589.364C658.171 589.759 658.444 589.967 658.824 590.007C659.254 590.058 659.756 589.942 660.313 589.668C660.789 589.435 661.239 589.147 661.655 588.812C662.08 588.468 662.475 588.098 662.84 587.709C663.209 587.309 663.559 586.903 663.878 586.493C663.948 586.402 664.06 586.351 664.171 586.357C664.288 586.362 664.389 586.422 664.455 586.519L665.959 588.883C666.04 589.01 666.03 589.172 665.939 589.288C665.721 589.572 665.397 589.911 664.987 590.301C664.581 590.686 664.111 591.071 663.604 591.451C663.245 591.719 662.87 591.962 662.485 592.18L663.619 594.19C663.665 594.276 663.68 594.377 663.65 594.469C663.619 594.56 663.553 594.641 663.467 594.681L661.665 595.567C661.579 595.613 661.477 595.618 661.386 595.583C661.295 595.547 661.224 595.476 661.184 595.39L660.232 593.147C659.827 593.269 659.442 593.344 659.097 593.38C658.262 593.461 657.543 593.38 656.961 593.142C656.378 592.904 655.902 592.575 655.533 592.16C655.183 591.765 654.91 591.365 654.717 590.97C654.327 590.175 654.17 589.41 654.256 588.686V588.691Z",
    fill: "#352F44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.119 592.549C645.177 594.965 646.818 596.97 648.803 598.469",
    stroke: "#352F44",
    strokeWidth: 1.0887,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.771 570.087C655.623 570.132 653.421 570.598 651.269 571.515C644.645 574.34 641.673 581.46 642.858 588.367",
    stroke: "#352F44",
    strokeWidth: 1.0887,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.76 609.898L653.183 609.194",
    stroke: "#352F44",
    strokeWidth: 1.0887,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.683 608.166L647.42 607.305",
    stroke: "#352F44",
    strokeWidth: 1.0887,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.326 604.702L642.453 603.654",
    stroke: "#352F44",
    strokeWidth: 1.0887,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.148 600.221L638.123 599.249",
    stroke: "#352F44",
    strokeWidth: 1.0887,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.237 593.729L635.211 592.757",
    stroke: "#352F44",
    strokeWidth: 1.0887,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.336 587.207L634.265 586.255",
    stroke: "#352F44",
    strokeWidth: 1.0887,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.313 581.197L634.706 580.513",
    stroke: "#352F44",
    strokeWidth: 1.0887,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.027 575.394L636.994 574.918",
    stroke: "#352F44",
    strokeWidth: 1.0887,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.801 505.357C633.89 493.929 646.712 487.472 658.019 492.658L663.139 494.678L662.809 495.514C670.921 501.63 674.218 511.935 670.719 521.88C667.215 531.836 657.108 536.94 646.935 535.8L646.611 536.621L641.491 534.6L641.501 534.58C629.419 530.438 623.738 516.725 628.801 505.362V505.357Z",
    fill: "#EAAE36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.921 507.378C628.857 518.746 634.538 532.453 646.62 536.595C658.389 540.631 671.711 535.633 675.838 523.896C679.96 512.178 674.648 499.954 663.138 494.678C651.826 489.493 639.01 495.949 633.921 507.378Z",
    fill: "#FFD576"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.265 509.874C636.736 517.799 640.695 527.359 649.121 530.251C657.33 533.066 666.617 529.577 669.498 521.394C672.374 513.221 668.667 504.699 660.641 501.018C652.752 497.402 643.815 501.904 640.265 509.874Z",
    fill: "#EAAE36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.937 514.781C650.52 514.361 651.249 514.092 652.104 513.981C652.925 513.869 653.902 513.854 655.006 513.935C655.619 513.976 656.161 513.996 656.621 513.991C657.031 513.991 657.371 513.925 657.629 513.804C657.852 513.697 658.019 513.505 658.13 513.216C658.272 512.862 658.232 512.563 658.014 512.274C657.761 511.94 657.305 511.641 656.657 511.388C656.009 511.135 655.33 510.963 654.636 510.882C653.932 510.801 653.143 510.781 652.282 510.821C652.17 510.821 652.059 510.776 651.988 510.689C651.917 510.598 651.892 510.482 651.922 510.375L652.656 507.783C652.697 507.631 652.839 507.525 652.996 507.525C653.608 507.525 654.338 507.575 655.163 507.687C655.533 507.737 655.907 507.808 656.297 507.909L657.042 505.641C657.072 505.55 657.138 505.474 657.229 505.433C657.315 505.393 657.416 505.388 657.507 505.423L659.376 506.157C659.467 506.193 659.538 506.264 659.573 506.355C659.609 506.446 659.609 506.547 659.568 506.633L658.581 508.76C659.285 509.12 659.862 509.53 660.298 509.981C660.936 510.639 661.336 511.373 661.482 512.153C661.629 512.933 661.543 513.733 661.234 514.528C660.915 515.343 660.46 515.951 659.882 516.346C659.32 516.725 658.657 516.968 657.918 517.07C657.214 517.166 656.434 517.196 655.609 517.161C654.819 517.13 654.15 517.12 653.619 517.13C653.137 517.141 652.758 517.217 652.489 517.348C652.251 517.465 652.074 517.677 651.948 517.996C651.785 518.407 651.816 518.746 652.039 519.055C652.292 519.404 652.712 519.698 653.294 519.931C653.791 520.123 654.307 520.265 654.829 520.346C655.366 520.427 655.907 520.473 656.439 520.478C656.981 520.483 657.518 520.467 658.034 520.427C658.151 520.417 658.262 520.462 658.333 520.554C658.404 520.64 658.434 520.761 658.404 520.873L657.669 523.577C657.629 523.718 657.507 523.825 657.356 523.835C656.996 523.865 656.53 523.855 655.968 523.81C655.411 523.764 654.814 523.678 654.186 523.556C653.745 523.47 653.315 523.359 652.894 523.217L652.17 525.41C652.14 525.501 652.074 525.577 651.983 525.617C651.897 525.658 651.796 525.663 651.704 525.627L649.836 524.893C649.745 524.858 649.674 524.787 649.638 524.696C649.603 524.605 649.603 524.503 649.644 524.417L650.661 522.204C650.297 521.987 649.983 521.754 649.725 521.521C649.102 520.959 648.676 520.371 648.459 519.779C648.241 519.191 648.165 518.614 648.226 518.062C648.286 517.536 648.398 517.065 648.555 516.66C648.879 515.839 649.345 515.206 649.932 514.781H649.937Z",
    fill: "#352F44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.265 509.874C639.192 512.284 638.812 514.842 639.04 517.323",
    stroke: "#352F44",
    strokeWidth: 1.0887,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.07 504.871C664.591 503.312 662.768 501.995 660.641 501.018C654.094 498.015 646.828 500.608 642.513 506.132",
    stroke: "#352F44",
    strokeWidth: 1.0887,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.568 527.197L634.047 527.779",
    stroke: "#352F44",
    strokeWidth: 1.0887,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.763 521.536L631.566 522.245",
    stroke: "#352F44",
    strokeWidth: 1.0887,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.72 515.242L630.928 516.113",
    stroke: "#352F44",
    strokeWidth: 1.0887,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.226 509.14L631.272 509.945",
    stroke: "#352F44",
    strokeWidth: 1.0887,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.077 502.618L634.123 503.423",
    stroke: "#352F44",
    strokeWidth: 1.0887,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.29 497.559L638.295 498.349",
    stroke: "#352F44",
    strokeWidth: 1.0887,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.4 494.248L642.843 494.815",
    stroke: "#352F44",
    strokeWidth: 1.0887,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.516 492.349L648.519 492.744",
    stroke: "#352F44",
    strokeWidth: 1.0887,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.178 562.719C563.428 551.148 565.839 538.317 574.969 534.945L579.911 532.717L579.258 533.998C587.349 533.329 595.674 538.768 600.282 548.247C604.895 557.731 603.001 567.864 597.062 573.469L598.961 573.581L593.502 576.042L593.492 576.021C584.635 580.645 572.903 574.229 568.178 562.724V562.719Z",
    fill: "#EAAE36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.143 560.03C578.868 571.535 590.6 577.951 599.457 573.328C608.08 568.821 611.686 556.739 606.247 545.553C600.814 534.383 590.226 528.823 580.934 532.256C571.804 535.628 569.394 548.46 574.143 560.03Z",
    fill: "#FFD576"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.004 557.838C582.296 565.859 590.484 570.335 596.657 567.109C602.672 563.97 605.184 555.539 601.391 547.741C597.603 539.953 590.221 536.074 583.739 538.469C577.374 540.824 575.693 549.771 579.004 557.838Z",
    fill: "#EAAE36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.116 555.296C587.147 554.622 587.344 553.964 587.709 553.336C588.058 552.739 588.549 552.106 589.162 551.462C589.501 551.108 589.79 550.779 590.023 550.48C590.23 550.217 590.362 549.959 590.418 549.705C590.463 549.488 590.423 549.245 590.296 548.956C590.139 548.606 589.927 548.414 589.628 548.343C589.283 548.262 588.858 548.333 588.362 548.556C587.866 548.779 587.41 549.088 587 549.467C586.59 549.852 586.169 550.338 585.754 550.91C585.698 550.986 585.612 551.017 585.516 550.997C585.42 550.976 585.334 550.905 585.278 550.804L583.987 548.444C583.911 548.308 583.916 548.141 583.992 548.044C584.306 547.655 584.711 547.229 585.207 546.789C585.43 546.591 585.668 546.409 585.931 546.232L584.853 544.105C584.807 544.019 584.792 543.918 584.812 543.836C584.832 543.75 584.878 543.685 584.949 543.654L586.377 543.011C586.448 542.981 586.529 542.986 586.605 543.031C586.681 543.072 586.747 543.148 586.782 543.239L587.648 545.416C588.24 545.234 588.797 545.168 589.314 545.219C590.063 545.295 590.742 545.578 591.319 546.054C591.896 546.53 592.367 547.168 592.722 547.948C593.081 548.743 593.243 549.477 593.198 550.131C593.157 550.764 592.975 551.361 592.656 551.903C592.357 552.419 591.977 552.931 591.532 553.432C591.106 553.908 590.757 554.328 590.494 554.673C590.256 554.987 590.109 555.28 590.058 555.549C590.013 555.787 590.058 556.055 590.2 556.364C590.382 556.764 590.615 556.992 590.929 557.078C591.284 557.174 591.689 557.124 592.134 556.921C592.514 556.749 592.869 556.526 593.188 556.253C593.517 555.974 593.826 555.66 594.099 555.331C594.383 554.992 594.646 554.637 594.884 554.283C594.935 554.202 595.026 554.166 595.122 554.187C595.218 554.207 595.304 554.273 595.36 554.374L596.722 556.815C596.793 556.946 596.798 557.098 596.727 557.205C596.56 557.453 596.317 557.741 595.998 558.066C595.684 558.385 595.325 558.704 594.924 559.007C594.646 559.22 594.347 559.412 594.043 559.575L595.081 561.635C595.127 561.722 595.142 561.818 595.122 561.909C595.102 561.995 595.056 562.061 594.985 562.091L593.557 562.734C593.486 562.765 593.405 562.76 593.329 562.714C593.253 562.668 593.188 562.598 593.152 562.506L592.251 560.243C591.922 560.314 591.613 560.344 591.334 560.339C590.656 560.324 590.058 560.162 589.567 559.868C589.076 559.574 588.666 559.205 588.342 558.764C588.033 558.344 587.79 557.929 587.607 557.529C587.243 556.724 587.076 555.969 587.106 555.286L587.116 555.296Z",
    fill: "#352F44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.004 557.838C580.007 560.278 581.46 562.385 583.172 564.056",
    stroke: "#352F44",
    strokeWidth: 1.0887,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589 537.841C587.238 537.638 585.456 537.831 583.739 538.469C578.453 540.424 576.397 546.915 577.744 553.68",
    stroke: "#352F44",
    strokeWidth: 1.0887,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.836 575.53L587.142 574.943",
    stroke: "#352F44",
    strokeWidth: 1.0887,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.734 573.631L581.835 572.684",
    stroke: "#352F44",
    strokeWidth: 1.0887,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.716 569.889L577.248 568.75",
    stroke: "#352F44",
    strokeWidth: 1.0887,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.146 565.069L574.148 563.717",
    stroke: "#352F44",
    strokeWidth: 1.0887,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.725 558.359L571.48 557.119",
    stroke: "#352F44",
    strokeWidth: 1.0887,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.484 552.065L570.148 550.86",
    stroke: "#352F44",
    strokeWidth: 1.0887,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.874 546.449L570.295 545.356",
    stroke: "#352F44",
    strokeWidth: 1.0887,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.88 541.148L572.072 540.16",
    stroke: "#352F44",
    strokeWidth: 1.0887,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.852 630.325C582.048 626.193 574.052 615.873 577.592 606.804L579.207 601.629L579.729 602.966C584.605 596.474 594.196 593.861 604.344 596.707C614.501 599.558 620.816 607.7 621.064 615.868L622.406 614.521L620.623 620.233H620.603C618.183 629.915 605.589 634.431 593.852 630.32V630.325Z",
    fill: "#EAAE36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.801 624.076C607.539 628.183 620.132 623.671 622.552 613.979C624.912 604.54 618.269 593.82 606.293 590.458C594.337 587.101 583.142 591.324 579.541 600.555C576.002 609.624 583.992 619.944 595.801 624.076Z",
    fill: "#FFD576"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.391 618.992C605.579 621.858 614.354 618.709 616.045 611.954C617.691 605.371 613.058 597.897 604.708 595.552C596.368 593.213 588.565 596.16 586.053 602.591C583.582 608.915 589.157 616.111 597.391 618.992Z",
    fill: "#EAAE36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.874 611.24C600.388 610.769 600.029 610.181 599.806 609.493C599.588 608.834 599.446 608.05 599.37 607.163C599.33 606.672 599.274 606.237 599.208 605.867C599.153 605.538 599.046 605.264 598.889 605.057C598.758 604.875 598.55 604.743 598.251 604.652C597.887 604.54 597.603 604.566 597.35 604.743C597.056 604.945 596.828 605.31 596.666 605.832C596.504 606.348 596.428 606.895 596.444 607.452C596.459 608.014 596.545 608.652 596.697 609.346C596.717 609.437 596.681 609.523 596.606 609.579C596.53 609.634 596.418 609.655 596.307 609.629L593.684 609.027C593.532 608.991 593.41 608.88 593.39 608.753C593.304 608.262 593.258 607.675 593.258 607.011C593.258 606.713 593.279 606.414 593.324 606.1L591.02 605.492C590.924 605.467 590.843 605.411 590.792 605.34C590.742 605.27 590.722 605.189 590.747 605.118L591.213 603.619C591.233 603.548 591.294 603.487 591.38 603.462C591.461 603.431 591.562 603.436 591.653 603.467L593.856 604.267C594.114 603.705 594.433 603.239 594.813 602.895C595.37 602.383 596.028 602.064 596.773 601.953C597.512 601.836 598.302 601.907 599.122 602.16C599.958 602.419 600.611 602.788 601.072 603.254C601.517 603.71 601.841 604.242 602.039 604.834C602.226 605.401 602.358 606.024 602.434 606.687C602.51 607.32 602.586 607.862 602.672 608.288C602.748 608.672 602.869 608.976 603.036 609.199C603.183 609.391 603.411 609.533 603.74 609.634C604.161 609.766 604.485 609.746 604.758 609.564C605.067 609.361 605.295 609.027 605.442 608.561C605.563 608.166 605.634 607.751 605.644 607.33C605.654 606.9 605.624 606.465 605.558 606.034C605.492 605.599 605.401 605.168 605.295 604.753C605.27 604.662 605.3 604.571 605.381 604.51C605.457 604.449 605.568 604.429 605.68 604.454L608.409 605.057C608.556 605.087 608.672 605.189 608.703 605.31C608.779 605.599 608.834 605.973 608.865 606.424C608.895 606.87 608.895 607.351 608.855 607.852C608.829 608.207 608.779 608.551 608.698 608.885L610.931 609.478C611.027 609.503 611.108 609.559 611.159 609.629C611.209 609.7 611.224 609.781 611.204 609.852L610.738 611.351C610.718 611.422 610.657 611.483 610.571 611.508C610.485 611.538 610.389 611.533 610.298 611.503L608.009 610.678C607.842 610.971 607.665 611.219 607.467 611.427C607.001 611.923 606.49 612.263 605.943 612.435C605.396 612.607 604.849 612.668 604.302 612.617C603.786 612.566 603.31 612.475 602.89 612.344C602.044 612.08 601.371 611.706 600.874 611.23V611.24Z",
    fill: "#352F44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.391 618.992C599.877 619.863 602.424 620.177 604.804 620.005",
    stroke: "#352F44",
    strokeWidth: 1.0887,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.076 598.241C587.755 599.421 586.717 600.884 586.053 602.591C584.002 607.837 587.496 613.69 593.446 617.174",
    stroke: "#352F44",
    strokeWidth: 1.0887,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.155 625.631L615.585 624.264",
    stroke: "#352F44",
    strokeWidth: 1.0887,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.685 628.932L610.374 626.73",
    stroke: "#352F44",
    strokeWidth: 1.0887,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.553 630.203L604.384 627.55",
    stroke: "#352F44",
    strokeWidth: 1.0887,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.578 629.672L598.561 626.522",
    stroke: "#352F44",
    strokeWidth: 1.0887,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.955 627.018L591.856 624.137",
    stroke: "#352F44",
    strokeWidth: 1.0887,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.425 623.767L586.296 620.977",
    stroke: "#352F44",
    strokeWidth: 1.0887,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.486 619.747L582.276 617.215",
    stroke: "#352F44",
    strokeWidth: 1.0887,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.852 614.729L579.566 612.435",
    stroke: "#352F44",
    strokeWidth: 1.0887,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.612 532.806L653.049 547.227C653.834 547.482 654.263 548.324 654.009 549.109L652.163 554.797C651.908 555.582 651.065 556.012 650.281 555.757L605.844 541.336C605.06 541.081 604.63 540.239 604.885 539.454L606.731 533.766C606.985 532.981 607.828 532.551 608.612 532.806Z",
    fill: "#EAAE36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.739 548.333L648.281 552.82",
    stroke: "#352F44",
    strokeWidth: 1.0887,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.212 546.216L641.754 550.698",
    stroke: "#352F44",
    strokeWidth: 1.0887,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.685 544.1L635.232 548.581",
    stroke: "#352F44",
    strokeWidth: 1.0887,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.158 541.978L628.705 546.465",
    stroke: "#352F44",
    strokeWidth: 1.0887,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.636 539.862L622.178 544.343",
    stroke: "#352F44",
    strokeWidth: 1.0887,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.109 537.745L615.656 542.226",
    stroke: "#352F44",
    strokeWidth: 1.0887,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.582 535.623L609.128 540.11",
    stroke: "#352F44",
    strokeWidth: 1.0887,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.004 511.952L611.89 480.88C612.506 480.331 613.451 480.386 613.999 481.002L617.977 485.468C618.526 486.084 618.471 487.028 617.855 487.577L582.968 518.649C582.352 519.198 581.408 519.143 580.859 518.527L576.882 514.061C576.333 513.445 576.388 512.501 577.004 511.952Z",
    fill: "#EAAE36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.204 484.302L614.339 487.822",
    stroke: "#352F44",
    strokeWidth: 1.0887,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.08 488.865L609.214 492.384",
    stroke: "#352F44",
    strokeWidth: 1.0887,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.955 493.432L604.09 496.952",
    stroke: "#352F44",
    strokeWidth: 1.0887,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.831 497.995L598.965 501.514",
    stroke: "#352F44",
    strokeWidth: 1.0887,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.706 502.557L593.841 506.076",
    stroke: "#352F44",
    strokeWidth: 1.0887,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.582 507.119L588.716 510.639",
    stroke: "#352F44",
    strokeWidth: 1.0887,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.458 511.682L583.592 515.201",
    stroke: "#352F44",
    strokeWidth: 1.0887,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.955 540.026L690.132 586.557C690.206 587.379 689.6 588.105 688.778 588.178L682.822 588.713C682 588.787 681.274 588.18 681.2 587.359L677.023 540.828C676.949 540.006 677.555 539.28 678.377 539.207L684.333 538.672C685.155 538.598 685.881 539.205 685.955 540.026Z",
    fill: "#EAAE36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.738 584.007L683.044 584.427",
    stroke: "#352F44",
    strokeWidth: 1.0887,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.125 577.171L682.43 577.591",
    stroke: "#352F44",
    strokeWidth: 1.0887,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.512 570.34L681.818 570.76",
    stroke: "#352F44",
    strokeWidth: 1.0887,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.899 563.504L681.205 563.924",
    stroke: "#352F44",
    strokeWidth: 1.0887,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.282 556.673L680.588 557.093",
    stroke: "#352F44",
    strokeWidth: 1.0887,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.669 549.837L679.975 550.257",
    stroke: "#352F44",
    strokeWidth: 1.0887,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.056 543.006L679.362 543.426",
    stroke: "#352F44",
    strokeWidth: 1.0887,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.085 371.964L676.172 450.416C676.977 451.348 678.385 451.444 679.316 450.639L682.932 447.499C683.864 446.694 683.96 445.281 683.155 444.355L615.068 365.903C614.263 364.971 612.855 364.875 611.923 365.68L608.308 368.819C607.376 369.624 607.28 371.037 608.085 371.964Z",
    fill: "#352F44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.446 361.629L692.153 432.728C693.788 434.612 690.861 437.159 689.221 435.27L627.514 364.171C625.879 362.287 628.806 359.735 630.446 361.629Z",
    fill: "#FFD576"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.384 365.249L682.856 451.059C684.35 452.781 686.957 452.968 688.679 451.469L694.918 446.056C696.639 444.562 696.827 441.955 695.328 440.233L620.856 354.423C619.362 352.701 616.754 352.514 615.033 354.013L608.794 359.426C607.072 360.92 606.885 363.528 608.384 365.249Z",
    fill: "#5C5470"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.132 435.979L679.939 441.352",
    stroke: "#352F44",
    strokeWidth: 1.28112,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.334 427.001L672.147 432.374",
    stroke: "#352F44",
    strokeWidth: 1.28112,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.541 418.018L664.353 423.391",
    stroke: "#352F44",
    strokeWidth: 1.28112,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.748 409.04L656.555 414.408",
    stroke: "#352F44",
    strokeWidth: 1.28112,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.955 400.057L648.762 405.43",
    stroke: "#352F44",
    strokeWidth: 1.28112,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.157 391.074L640.969 396.447",
    stroke: "#352F44",
    strokeWidth: 1.28112,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.364 382.096L633.176 387.469",
    stroke: "#352F44",
    strokeWidth: 1.28112,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.571 373.113L625.378 378.486",
    stroke: "#352F44",
    strokeWidth: 1.28112,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.778 364.135L617.585 369.508",
    stroke: "#352F44",
    strokeWidth: 1.28112,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.089 470.848C667.305 469.101 681.063 480.018 682.81 495.24L684.562 510.507",
    stroke: "#FAF0E6",
    strokeWidth: 1.28112,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.429 517.986L686.619 528.352",
    stroke: "#FAF0E6",
    strokeWidth: 1.28112,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.184 510.097C543.219 488.86 557.23 469.83 577.343 464.893L575.824 451.682C603.401 451.9 630.173 448.942 656.054 442.461L657.73 457.029C678.511 457.287 696.386 472.701 699.288 493.741L714.768 604.53C716.641 618.111 706.975 630.573 693.353 632.138L582.524 644.873C568.907 646.438 556.668 636.497 555.407 622.851L545.184 510.097Z",
    stroke: "#352F44",
    strokeWidth: 1.28112,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.825 451.682C618.947 437.817 656.054 442.461 656.054 442.461C608.253 453.626 575.825 451.682 575.825 451.682Z",
    fill: "#352F44",
    stroke: "#352F44",
    strokeWidth: 1.28112,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5519 194.697L30.1645 221.934L55.003 197.971C67.6831 207.874 76.8544 219.999 81.9955 232.982L71.1749 239.031L83.3501 236.734C87.9526 250.567 88.0367 265.199 82.9883 279.032L71.7891 277.08L80.8764 284.148C75.3231 296.096 65.7477 307.262 51.755 316.551L27.8926 291.712L43.6691 321.431C31.6958 328.011 17.0973 333.379 -0.345142 337.031V175C19.7899 178.172 36.921 185.223 50.5435 194.706L50.5519 194.697Z",
    fill: "#EAAE36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7941 257.829L82.1216 257.98",
    stroke: "#352F44",
    strokeWidth: 1.45,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6918 307.043L1.00149 256.011L71.1753 257.711",
    stroke: "#352F44",
    strokeWidth: 1.45,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9014 322.357L24.1824 313.194",
    stroke: "#352F44",
    strokeWidth: 1.45,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1055 226.032L59.3442 220.394",
    stroke: "#352F44",
    strokeWidth: 1.45,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3442 296.483L1.00074 256.011L42.0784 230.937",
    stroke: "#352F44",
    strokeWidth: 1.45,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00107 256.011L12.1919 212.384",
    stroke: "#352F44",
    strokeWidth: 1.45,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.643 284.762C118.294 284.998 124.201 271.678 128.458 261.102C153.499 251.451 174.054 245.763 190.504 243.146C187.315 253.134 182.696 269.423 186.364 269.777C189.974 270.122 198.985 252.713 204.362 241.589C251.792 238.771 253.181 268.229 222.486 295.566C215.965 293.193 208.838 291.191 207.694 293.269C206.625 295.204 210.462 298.797 214.661 301.961C200.155 312.857 180.508 322.954 156.688 329.929C145.783 324.839 130.848 318.293 129.367 319.841C127.819 321.465 134.718 329.155 139.607 334.22C115.61 339.277 88.1545 341.145 57.9982 337.948L64.2584 289.962C82.7274 280.656 99.5892 272.915 114.962 266.529C113.91 275.38 113.38 284.577 115.643 284.779V284.762Z",
    fill: "#B9B4C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.447 264.871C173.398 310.114 62.7352 313.909 62.7352 313.909",
    stroke: "#352F44",
    strokeWidth: 1.73,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.217 311.889L108.819 331.385",
    stroke: "#352F44",
    strokeWidth: 1.73,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.45 304.359L154.332 268.742",
    stroke: "#352F44",
    strokeWidth: 1.73,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.616 293.109L197.883 304.737",
    stroke: "#352F44",
    strokeWidth: 1.73,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.181 278.956L225.321 250.273",
    stroke: "#352F44",
    strokeWidth: 1.73,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-77.1071 252.86L304.456 392.778L360.267 310.126C360.267 310.126 379.107 233.028 383.246 228.602C387.386 224.176 398.131 230.891 395.64 244.362L389.935 286.466C389.935 286.466 450.206 189.889 456.415 187.507C462.634 185.118 474.826 191.454 462.743 213.019L435.523 268.88C435.523 268.88 523.804 204.277 531.225 203.233C539.69 202.047 553.254 213.793 518.747 241.198L452.141 297.833C452.141 297.833 497.148 310.783 502.71 314.426C508.272 318.069 554.078 366.249 555.281 371.777C556.485 377.305 534.212 388.555 514.616 366.913L484.536 346.332C484.536 346.332 442.145 337.733 437.77 344.019C433.394 350.304 443.937 385.929 448.17 386.072C452.402 386.215 493.025 378.449 493.025 378.449C527.624 376.817 555.416 396.75 546.388 407.798C537.359 418.845 514.397 412.787 497.805 417.137C481.212 421.487 435.431 442.851 435.431 442.851C401.833 481.985 369.758 485.494 335.362 488.666C300.965 491.838 -79.0003 415.698 -79.0003 415.698L-77.1071 252.86Z",
    fill: "#9E69FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.149 297.825L434.614 292.743",
    stroke: "#352F44",
    strokeWidth: 1.89,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.523 268.864L409.7 287.156",
    stroke: "#352F44",
    strokeWidth: 1.89,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.663 252.708C417.105 252.54 420.588 253.407 423.55 255.165Z",
    fill: "#9E69FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.663 252.708C417.105 252.54 420.588 253.407 423.55 255.165",
    stroke: "#352F44",
    strokeWidth: 1.89,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.759 205.185C454.085 204.159 463.054 194.685 462.457 192.236C461.86 189.788 457.442 188.929 455.709 190.234",
    fill: "#9E69FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.759 205.185C454.085 204.159 463.054 194.685 462.457 192.236C461.86 189.788 457.442 188.929 455.709 190.234",
    stroke: "#352F44",
    strokeWidth: 1.89,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.687 245.607C385.552 244.421 389.54 234.34 388.901 232.245C388.253 230.159 383.835 230.714 382.927 231.799",
    fill: "#9E69FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.687 245.607C385.552 244.421 389.54 234.34 388.901 232.245C388.253 230.159 383.835 230.714 382.927 231.799",
    stroke: "#352F44",
    strokeWidth: 1.89,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.433 270.656C374.201 269.158 377.457 268.561 380.579 268.99Z",
    fill: "#9E69FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.433 270.656C374.201 269.158 377.457 268.561 380.579 268.99",
    stroke: "#352F44",
    strokeWidth: 1.89,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.772 249.116C468.851 250.874 471.418 253.508 473.109 256.621Z",
    fill: "#9E69FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.772 249.116C468.851 250.874 471.418 253.508 473.109 256.621",
    stroke: "#352F44",
    strokeWidth: 1.89,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.431 216.141C520.422 219.33 532.984 214.39 534.524 211.681C536.064 208.963 532.664 205.286 530.502 205.572",
    fill: "#9E69FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.431 216.141C520.422 219.33 532.984 214.39 534.524 211.681C536.064 208.963 532.664 205.286 530.502 205.572",
    stroke: "#352F44",
    strokeWidth: 1.89,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.285 353.409C534.373 357.262 541.701 370.801 543.443 372.517C545.176 374.234 552.244 371.289 552.244 371.289",
    fill: "#9E69FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.285 353.409C534.373 357.262 541.701 370.801 543.443 372.517C545.176 374.234 552.244 371.289 552.244 371.289",
    stroke: "#352F44",
    strokeWidth: 1.89,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.389 316.412C499.833 318.869 498.268 321.326 496.711 323.783Z",
    fill: "#9E69FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.389 316.412C499.833 318.869 498.268 321.326 496.711 323.783",
    stroke: "#352F44",
    strokeWidth: 1.89,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.732 386.097C443.408 385.029 438.78 385.256 434.581 386.729Z",
    fill: "#9E69FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.732 386.097C443.408 385.029 438.78 385.256 434.581 386.729",
    stroke: "#352F44",
    strokeWidth: 1.89,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.077 412.333C518.453 410.238 518.638 399.055 521.44 397.204C524.242 395.361 545.336 397.288 544.158 405.854",
    fill: "#9E69FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.077 412.333C518.453 410.238 518.638 399.055 521.44 397.204C524.242 395.361 545.336 397.288 544.158 405.854",
    stroke: "#352F44",
    strokeWidth: 1.89,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.131 398.357C497.165 402.707 498.006 407.049 499.605 411.096Z",
    fill: "#9E69FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.131 398.357C497.165 402.707 498.006 407.049 499.605 411.096",
    stroke: "#352F44",
    strokeWidth: 1.89,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.297 285.877L386.343 293.323",
    stroke: "#352F44",
    strokeWidth: 1.89,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.308 434.201C548.331 444.206 571.798 436.826 580.389 417.491L580.423 417.507L583.906 410.532L584.503 409.354L584.47 409.337L583.191 408.698C586.548 392.072 579.598 374.638 563.67 367.41C559.101 365.332 554.398 364.179 549.753 363.893C539.631 363.253 529.77 366.695 522.071 373.577C521.002 374.528 519.976 375.546 518.999 376.623L517.678 375.959L516.055 379.223C516.055 379.223 516.012 379.307 515.996 379.349L515.474 380.376C515.474 380.376 515.541 380.393 515.575 380.393C519.462 381.268 523.114 382.387 526.48 383.691C531.032 385.45 535.028 387.545 538.301 389.8C540.085 391.02 541.642 392.29 542.98 393.578C548.079 398.508 549.711 403.75 546.404 407.798C543.872 410.894 540.237 412.653 535.962 413.671C531.671 414.689 526.715 414.966 521.566 415.101C518.629 415.185 515.625 415.227 512.647 415.328C516.189 423.027 522.348 429.784 530.316 434.21L530.308 434.201Z",
    fill: "#EAAE36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.549 415.093C524.949 419.451 529.299 423.221 534.381 426.039C552.025 435.842 574.886 428.968 583.898 410.532C584.092 410.137 584.277 409.741 584.462 409.329C592.834 390.49 586.515 367.772 567.751 359.248C559.724 355.605 551.285 354.797 543.443 356.514C534.33 358.499 526.034 363.876 520.127 372.13C519.244 373.342 518.428 374.621 517.662 375.959C517.048 377.027 516.509 378.121 516.038 379.223C516.013 379.257 515.996 379.307 515.979 379.349C515.828 379.694 515.685 380.048 515.558 380.401C519.446 381.276 523.098 382.395 526.463 383.7C531.015 385.458 535.012 387.553 538.285 389.808C540.069 391.028 541.625 392.299 542.963 393.586C548.062 398.517 549.695 403.759 546.388 407.806C543.855 410.902 540.22 412.661 535.946 413.679C531.655 414.697 526.699 414.975 521.549 415.109V415.093Z",
    fill: "#FFD576"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.946 413.662C537.039 414.487 538.209 415.244 539.429 415.926C540.531 416.54 541.659 417.061 542.812 417.482C543.022 417.566 543.224 417.634 543.434 417.709C543.72 417.819 544.023 417.903 544.309 417.995C544.579 418.071 544.839 418.147 545.1 418.214C545.378 418.29 545.664 418.357 545.942 418.425C547.616 418.812 549.307 419.014 551.007 419.039C560.633 419.224 570.107 413.847 574.348 404.28C580.196 391.146 575.795 375.302 562.703 369.362C559.236 367.788 555.66 366.972 552.143 366.871C545.63 366.669 539.32 368.874 534.271 373.157C534.095 373.3 533.926 373.451 533.758 373.603C533.632 373.704 533.522 373.821 533.396 373.922C533.228 374.074 533.06 374.225 532.9 374.393C532.572 374.705 532.252 375.033 531.949 375.361C531.806 375.513 531.663 375.664 531.52 375.824C531.352 376.009 531.192 376.194 531.032 376.388C530.88 376.564 530.737 376.733 530.586 376.918C530.35 377.195 530.131 377.481 529.904 377.784C529.778 377.953 529.643 378.129 529.526 378.306C529.408 378.466 529.298 378.626 529.189 378.786C529.021 379.03 528.869 379.265 528.71 379.509C528.541 379.753 528.398 380.006 528.238 380.258C528.087 380.511 527.935 380.763 527.784 381.024C527.489 381.545 527.22 382.059 526.968 382.589C526.791 382.959 526.631 383.338 526.471 383.708C531.023 385.466 535.02 387.562 538.293 389.817C540.077 391.037 541.634 392.307 542.971 393.595C548.07 398.525 549.703 403.767 546.396 407.814C543.863 410.911 540.228 412.669 535.954 413.687L535.946 413.662Z",
    fill: "#EAAE36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.869 387.621L538.503 389.177C538.428 389.388 538.36 389.598 538.293 389.8C540.077 391.02 541.634 392.29 542.971 393.578C543.03 393.157 543.106 392.745 543.182 392.366C543.417 391.23 543.788 390.136 544.318 389.11C544.831 388.075 545.386 387.368 545.975 386.998C546.48 386.678 546.985 386.661 547.549 386.947C548.003 387.183 548.306 387.469 548.441 387.856C548.6 388.302 548.659 388.874 548.6 389.547C548.55 390.305 548.432 391.205 548.281 392.198C547.986 394.007 547.877 395.622 547.936 397.002C547.995 398.433 548.34 399.67 548.945 400.696C549.568 401.739 550.536 402.589 551.848 403.246C552.496 403.574 553.253 403.826 554.12 404.003C555.02 404.18 555.98 404.137 556.989 403.868C557.999 403.591 559.026 402.976 560.044 402.034C560.473 401.647 560.894 401.159 561.314 400.587L564.814 402.589C564.966 402.673 565.126 402.69 565.277 402.648C565.437 402.598 565.563 402.488 565.631 402.345L567.12 399.367C567.187 399.224 567.204 399.055 567.145 398.912C567.095 398.761 566.968 398.635 566.825 398.567L563.308 397.053C563.603 396.38 563.847 395.69 564.057 394.974C564.352 393.956 564.579 392.98 564.73 392.063C564.882 391.138 564.966 390.372 564.974 389.783C564.974 389.539 564.823 389.312 564.587 389.228L560.237 387.621C560.06 387.545 559.859 387.578 559.699 387.688C559.539 387.789 559.446 387.966 559.446 388.159C559.429 389.017 559.387 389.901 559.295 390.801C559.202 391.676 559.051 392.568 558.832 393.443C558.622 394.293 558.319 395.126 557.923 395.917C557.461 396.842 556.914 397.499 556.291 397.852C555.744 398.18 555.189 398.18 554.532 397.852C554.028 397.608 553.699 397.28 553.54 396.868C553.363 396.405 553.287 395.765 553.338 394.966C553.396 394.091 553.514 392.989 553.674 391.685C553.851 390.33 553.918 389.043 553.868 387.865C553.809 386.628 553.497 385.492 552.959 384.507C552.395 383.498 551.453 382.656 550.157 382.008C548.895 381.377 547.582 381.125 546.278 381.251C544.966 381.386 543.703 381.941 542.517 382.892C541.709 383.54 540.952 384.44 540.254 385.542L536.88 383.607C536.745 383.523 536.577 383.506 536.417 383.557C536.265 383.599 536.131 383.708 536.055 383.851L534.574 386.83C534.498 386.973 534.49 387.141 534.549 387.292C534.608 387.444 534.726 387.57 534.869 387.637V387.621Z",
    fill: "#352F44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.429 415.926C543.249 418.046 547.422 419.047 551.545 419.039",
    stroke: "#352F44",
    strokeWidth: 1.84,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.919 372.601C534.7 372.778 534.481 372.955 534.263 373.148C534.086 373.291 533.909 373.434 533.749 373.594C533.623 373.695 533.514 373.813 533.388 373.914C533.219 374.065 533.051 374.217 532.891 374.385C532.563 374.696 532.243 375.025 531.94 375.353C531.797 375.504 531.654 375.656 531.511 375.816C531.343 376.001 531.183 376.186 531.023 376.379C530.872 376.556 530.729 376.724 530.577 376.909C530.342 377.187 530.123 377.473 529.896 377.776C529.769 377.944 529.635 378.121 529.517 378.298C529.399 378.458 529.29 378.617 529.18 378.777C529.012 379.021 528.861 379.257 528.701 379.501C528.533 379.745 528.381 379.997 528.23 380.25C528.07 380.502 527.927 380.755 527.775 381.015C527.481 381.537 527.203 382.059 526.959 382.58C526.782 382.951 526.623 383.329 526.463 383.7",
    stroke: "#352F44",
    strokeWidth: 1.84,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.91 431.155L568.079 428.799",
    stroke: "#352F44",
    strokeWidth: 1.84,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.149 434.967L558.588 432.089",
    stroke: "#352F44",
    strokeWidth: 1.84,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.607 435.766L548.365 432.249",
    stroke: "#352F44",
    strokeWidth: 1.84,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.61 434.041L538.234 430.785",
    stroke: "#352F44",
    strokeWidth: 1.84,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.261 428.395L527.885 425.131",
    stroke: "#352F44",
    strokeWidth: 1.84,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.528 420.696L520.119 417.499",
    stroke: "#352F44",
    strokeWidth: 1.84,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.072 371.335L35.1119 408.694L69.1723 375.828C86.5558 389.409 99.135 406.035 106.194 423.848L91.3519 432.144L108.054 428.997C114.364 447.971 114.482 468.039 107.566 487.004L92.2101 484.328L104.671 494.021C97.0482 510.404 83.9222 525.717 64.7296 538.465L32.007 504.396L53.6481 545.154C37.2322 554.174 17.215 561.545 -6.71476 566.551V344.326C20.9088 348.676 44.4011 358.344 63.072 371.344V371.335Z",
    fill: "#5C5470"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.6874 457.908L106.362 458.118",
    stroke: "#352F44",
    strokeWidth: 1.99,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4832 525.406L-4.8976 455.426L91.3516 457.757",
    stroke: "#352F44",
    strokeWidth: 1.99,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0068 546.416L26.8995 533.837",
    stroke: "#352F44",
    strokeWidth: 1.99,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4579 414.306L75.1211 406.573",
    stroke: "#352F44",
    strokeWidth: 1.99,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1211 510.925L-4.8972 455.426L51.4437 421.029",
    stroke: "#352F44",
    strokeWidth: 1.99,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4.89728 455.426L10.4585 395.593",
    stroke: "#352F44",
    strokeWidth: 1.99,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_65_1404"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H722C759.555 0 790 30.4446 790 68V914C790 951.555 759.555 982 722 982H0V0Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_65_1404"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1040.5,
    height: 907,
    fill: "white",
    transform: "matrix(-1 0 0 1 719.252 162)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegisterDark);
export default __webpack_public_path__ + "static/media/register-dark.488c228262208b4d437817c1eb3d2500.svg";
export { ForwardRef as ReactComponent };